export const GROUP_SIZES = {
  PAIR: "pair",
  POD: "pod",
  SQUAD: "squad"
}
